import { render, staticRenderFns } from "./StandortLieferungPlz.vue?vue&type=template&id=4931ca4e"
import script from "./StandortLieferungPlz.vue?vue&type=script&lang=ts"
export * from "./StandortLieferungPlz.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports